import clsx from "clsx";

import { AssessmentSession } from "@api/assessments/assessment-schema-types";

interface SessionRailProps {
  sessions: AssessmentSession[];
  currentSessionId: number;
  onSelectSession: (sessionId: number) => void;
}

export const SessionRail: React.FC<SessionRailProps> = ({ sessions, currentSessionId, onSelectSession }) => {
  if (sessions.length < 2) return null;
  // More than 4 sessions wrap into a fixed 4-column grid; up to 4 stay in a row.
  const useGrid = sessions.length > 4;
  return (
    <div className={useGrid ? "grid grid-cols-4 gap-2 w-full" : "flex flex-row flex-wrap gap-2 w-full"}>
      {sessions?.map((session) => (
        <button
          key={session.Id}
          type="button"
          className={clsx(
            "flex items-start gap-2 p-2 rounded-md border-2 text-left transition-colors min-w-0",
            !useGrid && "flex-1",
            currentSessionId === session.Id ? "bg-limestone-300" : "hover:bg-limestone-200",
          )}
          onClick={() => onSelectSession(session.Id)}
          style={{
            borderColor: `var(--chart-${session.Id})`,
          }}
        >
          <div
            className="flex items-center justify-center w-8 h-8 border-2 rounded-full font-semibold bg-white text-sm shrink-0"
            style={{
              borderColor: `var(--chart-${session.Id})`,
              color: currentSessionId === session.Id ? "white" : `var(--chart-${session.Id})`,
              backgroundColor: currentSessionId === session.Id ? `var(--chart-${session.Id})` : "white",
            }}
          >
            {session.Id}
          </div>
          <div className="flex flex-col min-w-0">
            <div className="text-xs font-medium text-gray-900 truncate">{session.Date}</div>
            <div className="text-xs text-gray-600 truncate">{session.Assessor || "Unknown"}</div>
          </div>
        </button>
      ))}
    </div>
  );
};
